import { createType } from './create-type.js';
import { NumberTypeDescription } from './number-type-description.js';

export const number = () =>
  createType<NumberTypeDescription>({
    description: { type: 'number' },
  });
